import type { HttpClient } from '@/lib/http/client.js'
import type { AppCatalogEntry, AppCategory, CreateAppInput, UpdateAppInput } from '@/types/app-catalog/app-catalog.type.js'

/** `admin/apps` and the category list, verified against the app-catalog admin controllers. */
export interface AppCatalogService {
  list: () => Promise<readonly AppCatalogEntry[]>
  create: (input: CreateAppInput) => Promise<AppCatalogEntry>
  update: (id: string, input: UpdateAppInput) => Promise<AppCatalogEntry>
  /** 204. */
  remove: (id: string) => Promise<void>
  /** Needs `app-category-view`; the create form falls back to an existing app's category without it. */
  categories: () => Promise<readonly AppCategory[]>
}

export function createAppCatalogService(http: HttpClient): AppCatalogService {
  return {
    list: () => http.get<readonly AppCatalogEntry[]>('admin/apps'),
    create: (input) => http.post<AppCatalogEntry>('admin/apps', input),
    update: (id, input) => http.patch<AppCatalogEntry>(`admin/apps/${encodeURIComponent(id)}`, input),
    remove: async (id) => {
      await http.delete(`admin/apps/${encodeURIComponent(id)}`)
    },
    categories: () => http.get<readonly AppCategory[]>('admin/app-categories'),
  }
}
